<template>
  <div class="authentication">
    <el-row>
      <el-col>

        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <!-- <el-form-item label="身份证号码" prop="identityCard">
            <el-input v-model="ruleForm.identityCard" placeholder="请输入身份证号码"></el-input>
          </el-form-item> -->
          <el-form-item label="身份证正面" prop="identityCardFront">
            <el-row type="flex" class="row-bg" justify="space-start" v-if="ruleForm.identityCardFront">
              <el-col>
                <el-image style="width: 300px; height: 180px" :src="ruleForm.identityCardFrontText"
                          :preview-src-list="[ruleForm.identityCardFrontText]"></el-image>
              </el-col>
            </el-row>
            <!-- 上传按钮 -->
            <el-row type="flex" class="row-bg" justify="flex-start">
              <!-- <el-col :span="10">
                <div class="front-img">
                  <img src="../../../assets/images/idCard3.png" alt />
                </div>
                <span>样本示例</span>
              </el-col>-->
              <el-col>
                <el-upload :limit="1" :headers="{'uploadType':'doctor_profile'}"
                           :on-success="function (res,file) {return handleLearnDataSuccess(res,file,'identityCardFront')}" :before-upload="beforeAvatarUpload"
                           :action="uploadUrl" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                           :on-exceed="handleExceed">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-col>
            </el-row>
            <el-popover placement="left-end" width="400" trigger="hover">
              <div class="front-img">
                <img src="../../../../../assets/images/idCard3.png" alt />
              </div>
              <span>身份证正面--样本示例</span>
              <el-button style="margin-top: 20px;" slot="reference">样本示例</el-button>
            </el-popover>
          </el-form-item>
          <el-form-item label="身份证反面" prop="identityCardBack">
            <el-row type="flex" class="row-bg" justify="space-start" v-if="ruleForm.identityCardBack">
              <el-col>
                <el-image style="width: 300px; height: 180px" :src="ruleForm.identityCardBackText"
                          :preview-src-list="[ruleForm.identityCardBackText]"></el-image>
              </el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="flex-start">
              <!-- <el-col :span="10">
                <div class="front-img">
                  <img src="../../../../../assets/images/idCard2.png" alt />
                </div>
                <span>样本示例</span>
              </el-col>-->
              <el-col>
                <el-upload :limit="1" :headers="{'uploadType':'doctor_profile'}"
                           :on-success="function (res,file) {return handleLearnDataSuccess(res,file,'identityCardBack')}" :before-upload="beforeAvatarUpload"
                           :action="uploadUrl" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                           :on-exceed="handleExceed">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-col>
            </el-row>
            <el-popover style="margin-top: 20px;" placement="left-end" width="400" trigger="hover">
              <div class="front-img">
                <img src="../../../../../assets/images/idCard2.png" alt />
              </div>
              <span>身份证反面--样本示例</span>
              <el-button style="margin-top: 20px;" slot="reference">样本示例</el-button>
            </el-popover>
          </el-form-item>
          <!-- <el-form-item label="电子签名" prop="signature">
            <el-row type="flex" class="row-bg" justify="space-start" v-if="ruleForm.signature">
              <el-col :span="9">
                <el-image :src="ruleForm.signature_text" :preview-src-list="signature_text_list"></el-image>
              </el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="flex-start">
              <el-col :span="10">
                <div class="front-img">
                  <img src="../../../assets/images/idCard1.png" alt />
                </div>
                <span>样本示例</span>
              </el-col>
              <el-col :span="10">
                <el-upload
                  :limit="1"
                  :on-success="function (res,file) {return handleLearnDataSuccess(res,file,'signature')}"
                  :before-upload="beforeAvatarUpload"
                  :action="uploadUrl"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-col>
            </el-row>
          </el-form-item>-->

          <el-form-item>

            <div class="loginBtn" v-if="ruleForm.status === 0 || ruleForm.status === -1">

              <el-button  class="customBtn" style="width: 100%"  type="primary"
                          @click="submitForm('ruleForm')">保存并下一步
              </el-button>
            </div>
            <div class="loginBtn" v-else>
              <el-button  style="width: 100%"  @click="$router.back(-1)" v-if="againChange">上一步</el-button>
            </div>

          </el-form-item>
        </el-form>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import util from "@/utils";
import {mapState} from 'vuex'
import { doctorEdit, getDoctorInfo } from "@/api/index.js";
export default {
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      uploadUrl: process.env.VUE_APP_BASE_API + "sys/upload/fileUpload",
      ruleForm: {},

      rules: {
        identityCard: [
          {
            required: true,
            message: "身份证号码不能为空",
            trigger: "blur",
          },
          {
            min: 15,
            max: 18,
            message: "长度在 15 到 18 个数字",
            trigger: "blur",
          },
          {
            // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "证件号码格式有误！",
            trigger: "blur",
          },
        ],
        identityCardFront: [
          {
            required: true,
            message: "身份证正面不能为空",
            trigger: "blur"
          }
        ],
        identityCardBack: [
          {
            required: true,
            message: "身份证正面不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    this.getUserInfo();
    this.$store.commit('updateActive', 2)
  },
  computed:{
    ...mapState(['againChange'])
  },
  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    /**
     * @desc 个人信息回显
     */
    async getUserInfo() {
      try {
        const params = {
          id: util.getStore("user_id"),
        };
        let res = await getDoctorInfo(params)  
        if (res.success) this.ruleForm = res.result;
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type
      });
    },
    /**
     * 提交保存按钮
     */
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        try {
          if (valid) {
            let res = await doctorEdit(this.ruleForm);
            if (res.success) {
              this.elementTips("success", res.message);
              this.getUserInfo();
              if(this.ruleForm.status === 0 || this.ruleForm.status === -1){
                this.$router.push('/index/user/auditInformation/qualifications')
              }
            } else {
              this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
              this.elementTips("warning", res.message);
            }
          } else {
            return false;
          }
        } catch (error) {
          console.log(error);
        }
      });
    },
    // 上传成功的回调
    handleLearnDataSuccess(res, file, index) {
      if (res.success) {
        this.ruleForm[index] = res.result.relativePath;
        this.ruleForm[`${index}Text`] = res.result.absolutePath;
        this.elementTips("success", res.message);
      } else {
        this.elementTips("warning", res.message);
      }
    },

    beforeAvatarUpload(file) {
      const isJPG = /^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt200k = file.size / 1024 < 200;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt200k) {
        this.$message.error("上传头像图片大小不能超过 200kb!");
      }
      return isJPG && isLt200k;
    },
    /**
     * 删除函数
     */
    handleRemove(file, fileList) {
      if (!file.response) {
        return;
      }
      if (
        this.ruleForm.identityCardFront.indexOf(file.response.result.relativePath) != -1
      ) {
        this.ruleForm.identityCardFront = "";
        this.ruleForm.identityCardFrontText = "";
      } else if (
        this.ruleForm.identityCardBack.indexOf(file.response.result.relativePath) != -1
      ) {
        this.ruleForm.identityCardBackText = "";
        this.ruleForm.identityCardBack = "";
      }
      //  else if (
      //   this.ruleForm.signature.indexOf(file.response.result.url) != -1
      // ) {
      //   this.ruleForm.signature = "";
      //   this.ruleForm.signature_text = "";
      // }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.front-img {
  display: block;
  /* float: right; */
  width: 300px;
  height: 200px;
}

.front-img img {
  width: 100%;
  height: 100%;
}
.authentication{
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 3% 0 3% 0;
}
.authentication .el-col-10 {
  width: 400px;
}
/deep/.el-input__inner:focus {
  border: 1px solid #fc701a !important;
}
// /deep/.el-upload:focus {
//   border: 1px solid #fc701a !important;
// }
</style>
